export default defineNuxtPlugin(() => {
  if (localStorage.getItem("nuxt-color-mode") !== null) {
    localStorage.removeItem("nuxt-color-mode");
  }
});
